/**
 * Subscription gift offers. The free gummy won the free vape (A) vs free gummy (B) test and,
 * when its setting is on, goes to every visitor. The free vape (winner of the earlier 5% vs
 * free vape test) is its fallback. The Intelligems experiments behind both stay available.
 * Mode 'vape' means "gift offer on regular plans"; giftType says which gift.
 */
(function () {
  'use strict';
  if (window.csSubscriptionIncentive) return;
  let config = {};
  try { config = JSON.parse(document.getElementById('cs-subscription-incentive-config')?.textContent || '{}'); } catch (_) {}
  const marker = 'with 5% discount';
  const frequency = (name) => String(name || '').toLowerCase().replace(marker, '').replace(/\s+/g, ' ').trim();
  const rolloutEnabled = Boolean(config.winnerEnabled);
  const giftReady = Boolean(config.gift?.ready && Number(config.gift.variantId) > 0);
  const gummyReady = Boolean(config.gummy?.ready && Number(config.gummy.variantId) > 0);
  // Everyone gets the gummy, with no Intelligems read. If the gummy can't be given for $0,
  // the free vape rollout (or the 5% baseline) takes over.
  const gummyRollout = Boolean(config.gummyWinnerEnabled && gummyReady);
  const giftTest = config.giftTest || {};
  // Both gifts must be sellable at $0, otherwise neither arm runs and the current offer stays.
  const giftTestConfigured = Boolean(!gummyRollout && giftTest.enabled && giftTest.experimentId && giftTest.vapeGroupId &&
    giftTest.gummyGroupId && giftTest.vapeGroupId !== giftTest.gummyGroupId && giftReady && gummyReady);
  const configured = Boolean(!gummyRollout && !rolloutEnabled && !giftTestConfigured && config.enabled && config.experimentId &&
    config.discountGroupId && config.vapeGroupId && config.discountGroupId !== config.vapeGroupId);
  const giftRuleIds = { vape: 'subscription-vape', gummy: 'subscription-gummy' };
  const giftVariantIds = new Set([config.gift?.variantId, config.gummy?.variantId].map(Number).filter((id) => id > 0));
  const products = new Map();
  const discountOnlyProducts = new Set(config.discountOnlyProductHandles || []);
  const itemHandle = (item) => item.handle || String(item.url || '').match(/\/products\/([^?/#]+)/)?.[1];
  // Vape products keep 5% off instead of a second vape. With the gummy (the rollout, or test
  // group B) they use regular plans and earn it like any other subscription.
  const isDiscountOnly = (handle) => giftType !== 'gummy' && discountOnlyProducts.has(String(handle || ''));
  let groupId = '';
  let giftGroupId = '';
  let giftType = 'vape';
  let mode = 'discount';
  let giftCheckedAt = 0;
  let giftCheckedVariant = 0;

  const activeGift = () => (giftType === 'gummy' ? config.gummy : config.gift);
  const inGiftTest = () => giftTestConfigured && [giftTest.vapeGroupId, giftTest.gummyGroupId].includes(giftGroupId);

  function read(experimentId) {
    try { return String(window.igData?.user?.getTestGroup(experimentId)?.id || ''); } catch (_) { return ''; }
  }

  function decide() {
    const nextGroup = configured ? read(config.experimentId) : '';
    const nextGiftGroup = giftTestConfigured ? read(giftTest.experimentId) : '';
    const nextGiftType = gummyRollout || (giftTestConfigured && nextGiftGroup === giftTest.gummyGroupId) ? 'gummy' : 'vape';
    const giftTestAssigned = giftTestConfigured && [giftTest.vapeGroupId, giftTest.gummyGroupId].includes(nextGiftGroup);
    const nextMode = gummyRollout ||
      (giftReady && (rolloutEnabled || giftTestAssigned || (configured && nextGroup === config.vapeGroupId))) ? 'vape' : 'discount';
    const changed = nextMode !== mode || nextGroup !== groupId || nextGiftGroup !== giftGroupId || nextGiftType !== giftType;
    groupId = nextGroup;
    giftGroupId = nextGiftGroup;
    giftType = nextGiftType;
    mode = nextMode;
    document.body.dataset.csSubscriptionIncentive = mode;
    // CSS swaps the vape badge and copy for the gummy version from this attribute.
    document.body.dataset.csSubscriptionGift = giftType;
    if (changed) document.dispatchEvent(new CustomEvent('cs:subscription-incentive-changed'));
  }

  function usesDiscount(handle = config.pageProductHandle) {
    return document.body.dataset.csSubscriptionDiscountEnabled !== 'false' &&
      (mode !== 'vape' || isDiscountOnly(handle));
  }

  // Existing cart guards use this signal for both experiment assignment and rollout.
  function isOfferActive() {
    return gummyRollout || (giftReady && (rolloutEnabled || inGiftTest() ||
      (configured && [config.discountGroupId, config.vapeGroupId].includes(groupId))));
  }

  function giftRule() {
    return mode === 'vape' ? {
      id: giftRuleIds[giftType], kind: 'subscription', variantId: Number(activeGift().variantId), thresholdCents: 0
    } : null;
  }

  function qualifies(rule, cart) {
    if (rule.kind !== 'subscription') return null;
    return mode === 'vape' && rule.id === giftRuleIds[giftType] &&
      Number(rule.variantId) === Number(activeGift().variantId) && (cart.items || []).some((item) =>
        item.quantity > 0 && !giftVariantIds.has(Number(item.variant_id)) &&
        String(item.properties?._cs_free_gift || '').toLowerCase() !== 'true' &&
        item.selling_plan_allocation?.selling_plan?.id && !isDiscountOnly(itemHandle(item)));
  }

  async function request(url, body) {
    const root = window.Shopify?.routes?.root || '/';
    const response = await fetch(root + url, {
      credentials: 'same-origin', cache: 'no-store',
      ...(body ? { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(body) } : {})
    });
    const data = await response.json();
    if (!response.ok || data.status >= 400) throw new Error(config.error || 'Unable to update your subscription offer. Please try again.');
    return data;
  }

  function product(handle) {
    if (!products.has(handle)) {
      products.set(handle, request('products/' + encodeURIComponent(handle) + '.js').catch((error) => {
        products.delete(handle);
        throw error;
      }));
    }
    return products.get(handle);
  }

  // Preview switches and late SDK assignment must also repair subscriptions already in the cart.
  // Each line keeps its own product, delivery cadence, quantity and custom properties.
  async function normalizeCart(cart, mutate) {
    if (!isOfferActive()) return cart;
    if (!cart || !Array.isArray(cart.items)) throw new Error(config.error);
    let changed = false;
    // A plan change can merge lines and change keys; always work from the latest cart response.
    const visited = new Set();
    for (;;) {
      const item = (cart.items || []).find((line) => line.selling_plan_allocation?.selling_plan?.id &&
        line.properties?._cs_free_gift !== 'true' && !visited.has(line.key));
      if (!item) break;
      visited.add(item.key);
      const current = item.selling_plan_allocation.selling_plan;
      const handle = itemHandle(item);
      if (!handle) throw new Error(config.error);
      const data = await product(handle);
      const variant = data.variants?.find((candidate) => String(candidate.id) === String(item.variant_id));
      const allocated = new Set((variant?.selling_plan_allocations || []).map((plan) => String(plan.selling_plan_id)));
      const plans = (data.selling_plan_groups || []).flatMap((group) => group.selling_plans || [])
        .filter((plan) => allocated.has(String(plan.id)) && frequency(plan.name) === frequency(current.name));
      const regular = plans.find((plan) => !plan.name.toLowerCase().includes(marker));
      const discounted = plans.find((plan) => plan.name.toLowerCase().includes(marker));
      const target = (usesDiscount(handle) && discounted) || regular;
      if (!target) throw new Error(config.error);
      if (String(target.id) === String(current.id)) continue;
      // Shopify requires a current 1-based line index when changing a selling plan.
      const body = { line: cart.items.findIndex((line) => line.key === item.key) + 1, quantity: item.quantity, selling_plan: Number(target.id) };
      cart = await (mutate ? mutate(body) : request('cart/change.js', body));
      changed = true;
    }
    if (changed) document.querySelector('cart-drawer')?.requestRefresh?.({ immediate: true });
    return cart;
  }

  async function ensureGiftAvailable() {
    const gift = activeGift();
    if (mode !== 'vape' || (giftCheckedVariant === Number(gift.variantId) && Date.now() - giftCheckedAt < 30000)) return;
    const data = await request('products/' + encodeURIComponent(gift.handle) + '.js');
    const variant = data.variants?.find((item) => String(item.id) === String(gift.variantId));
    if (!variant?.available || (variant.price !== 0 && !gift.automaticDiscount) || data.requires_selling_plan || variant.requires_selling_plan) {
      throw new Error(config.error);
    }
    giftCheckedAt = Date.now();
    giftCheckedVariant = Number(gift.variantId);
  }

  // Product catalog prices do not include automatic discounts. Check the actual
  // cart after reconciliation, including when an existing gift's discount expires.
  async function ensureGiftIsFree(remove) {
    const rule = giftRule();
    if (!rule) return;
    const cart = await request('cart.js');
    if (!qualifies(rule, cart)) return;
    const lines = (cart.items || []).filter((item) =>
      String(item.properties?._cs_free_gift || '').toLowerCase() === 'true' &&
      item.properties?._cs_free_gift_rule === rule.id);
    if (lines.length === 1 && Number(lines[0].variant_id) === rule.variantId &&
      lines[0].quantity === 1 && !lines[0].selling_plan_allocation &&
      typeof lines[0].final_line_price === 'number' && lines[0].final_line_price === 0) return;
    // A failed/partial discount must never leave a paid item advertised as a gift.
    const updates = Object.fromEntries(lines.map((line) => [line.key, 0]));
    if (Object.keys(updates).length) {
      await (remove ? remove(updates) : request('cart/update.js', { updates }));
    }
    throw new Error(config.error);
  }

  async function waitForSelectionWrites() {
    if (!window.csSubscriptionIncentive.isAssigned()) return;
    const start = Date.now();
    for (;;) {
      const manager = window.productSelectionManager;
      const pending = manager && (manager._selectionToCartSyncTimer || manager._isSyncingSelectionToCart ||
        manager._queuedSelectionToCartSync || manager._pendingFirstAddPromise || manager._isCommittingSelections);
      if (!pending && !document.querySelector('[data-add-to-cart].is-loading')) return;
      if (Date.now() - start > 8000) throw new Error(config.error);
      await new Promise(resolve => window.setTimeout(resolve, 40));
    }
  }

  window.csSubscriptionIncentive = {
    // isVape: the product earns the subscription gift (vape or gummy, see giftType).
    isVape: (handle = config.pageProductHandle) => mode === 'vape' && !isDiscountOnly(handle), usesDiscount, giftRule, qualifies, normalizeCart, ensureGiftAvailable, ensureGiftIsFree, waitForSelectionWrites,
    giftType: () => giftType,
    isAssigned: isOfferActive,
    errorMessage: () => config.error || 'Unable to update your subscription offer. Please try again.'
  };
  function init() {
    decide();
    window.addEventListener('ig:ready', decide);
    window.addEventListener('pageshow', decide);
    if (configured || giftTestConfigured) {
      const previous = window.onIgReady;
      window.onIgReady = [...(Array.isArray(previous) ? previous : typeof previous === 'function' ? [previous] : []), decide];
    }
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
